module.exports = __webpack_public_path__ + "static/media/intro.410b9adf.wav";